import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export class NamePromptModel {
  constructor(
    public title: string,
    public initialValue: string,
    public confirmLabel: string = 'Save'
  ) {}
}

@Component({
  selector: 'ze-name-prompt-modal',
  templateUrl: './name-prompt-modal.component.html',
  styleUrls: ['./name-prompt-modal.component.scss']
})
export class NamePromptModalComponent {
  title: string;
  value: string;
  confirmLabel: string;

  constructor(
    public dialogRef: MatDialogRef<NamePromptModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NamePromptModel
  ) {
    this.title = data.title;
    this.value = data.initialValue;
    this.confirmLabel = data.confirmLabel;
  }

  onConfirm(): void {
    const trimmed = (this.value || '').trim();
    if (!trimmed) return;
    this.dialogRef.close(trimmed);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
